/** Atualiza preview/unread de uma conversa sem refetch global. */
export function patchPortalConversation(directory, workspaceSlug, spaceId, patch) {
  const slug = String(workspaceSlug || "").trim();
  const sid = Number(spaceId);
  if (!slug || !Number.isFinite(sid) || sid <= 0) return directory;

  return (directory || []).map((ws) => {
    if (ws.workspaceSlug !== slug) return ws;
    const conversations = (ws.conversations || []).map((c) =>
      Number(c.id) === sid ? { ...c, ...patch } : c
    );
    if (patch.lastMessageAt) {
      conversations.sort((a, b) => {
        const ta = new Date(a.lastMessageAt || a.updatedAt || 0).getTime();
        const tb = new Date(b.lastMessageAt || b.updatedAt || 0).getTime();
        return tb - ta;
      });
    }
    return { ...ws, conversations };
  });
}

export function clearPortalConversationUnread(directory, workspaceSlug, spaceId) {
  return patchPortalConversation(directory, workspaceSlug, spaceId, {
    unreadCount: 0,
    hasUnread: false,
  });
}

/** Mescla entrada de um workspace após refresh parcial (?workspace=). */
export function mergePortalWorkspaceEntry(directory, entry) {
  if (!entry?.workspaceSlug) return directory;
  const slug = entry.workspaceSlug;
  const prev = Array.isArray(directory) ? directory : [];
  const idx = prev.findIndex((w) => w.workspaceSlug === slug);
  if (idx < 0) {
    const next = [...prev, entry];
    next.sort((a, b) =>
      String(a.workspaceLabel || "").localeCompare(String(b.workspaceLabel || ""), undefined, {
        sensitivity: "base",
      })
    );
    return next;
  }
  const next = [...prev];
  next[idx] = entry;
  return next;
}
